"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var EntryHandlerKeyword_1 = require("./EntryHandlerKeyword");
/**
 * Handles @id entries.
 */


var EntryHandlerKeywordId =
/*#__PURE__*/
function (_EntryHandlerKeyword_) {
  _inherits(EntryHandlerKeywordId, _EntryHandlerKeyword_);

  function EntryHandlerKeywordId() {
    _classCallCheck(this, EntryHandlerKeywordId);

    return _possibleConstructorReturn(this, _getPrototypeOf(EntryHandlerKeywordId).call(this, '@id'));
  }

  _createClass(EntryHandlerKeywordId, [{
    key: "handle",
    value: function () {
      var _handle = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(parsingContext, util, key, keys, value, depth) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // Error if an @id for this node already existed.
                if (parsingContext.idStack[depth] !== undefined) {
                  parsingContext.emitError(new Error("Found duplicate @ids '".concat(parsingContext.idStack[depth].value, "' and '").concat(value, "'")));
                } // Save our @id on the stack


                _context.t0 = util;
                _context.next = 4;
                return parsingContext.getContext(keys);

              case 4:
                _context.t1 = _context.sent;
                _context.t2 = value;
                _context.next = 8;
                return _context.t0.resourceToTerm.call(_context.t0, _context.t1, _context.t2);

              case 8:
                parsingContext.idStack[depth] = _context.sent;

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function handle(_x, _x2, _x3, _x4, _x5, _x6) {
        return _handle.apply(this, arguments);
      }

      return handle;
    }()
  }]);

  return EntryHandlerKeywordId;
}(EntryHandlerKeyword_1.EntryHandlerKeyword);

exports.EntryHandlerKeywordId = EntryHandlerKeywordId;